import { render, staticRenderFns } from "./purinvoiceabstract.vue?vue&type=template&id=1a7ca98b&scoped=true&"
import script from "./purinvoiceabstract.vue?vue&type=script&lang=js&"
export * from "./purinvoiceabstract.vue?vue&type=script&lang=js&"
import style0 from "./purinvoiceabstract.vue?vue&type=style&index=0&id=1a7ca98b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7ca98b",
  null
  
)

export default component.exports